// extracted by mini-css-extract-plugin
export default {"projectCard":"Project_projectCard__pXgHB","thumbImg":"Project_thumbImg__ThEhR","tagBody":"Project_tagBody__qS5Ml","tagTitle":"Project_tagTitle__v6OVx"};